<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">To Roddy Campbell a true marine. Rest easy cousin.</p><br/>
<p style="text-align: center;">To Austin Macauley Publishers. Thank you again for letting Zin’s ongoing story fly.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?e5dcb2f6